"use strict";

console.warn("You are trying to use an react-bootstrap-components component without adding it.");